import React from 'react';
import { OrderDetails } from '../components/OrderDetails';
import { useWarehouseAppContext } from '../hooks/useWarehouseAppContext';

export const OrderDetailsPage: React.FC = () => {
  const { selectedOrder } = useWarehouseAppContext();

  if (!selectedOrder) {
    return null;
  }

  return <OrderDetails order={selectedOrder} />;
};
